export const productionTypeByProcess = {
  elaboration: 'elaboration_process',
  packaging: 'packaging_process'
};
